import axios, { AxiosError } from 'axios';
import type { ApiErrorBody } from '@/types/contracts';

export class ApiError extends Error {
  readonly code: string;
  readonly requestId?: string;
  readonly status?: number;

  constructor(body: ApiErrorBody, fallbackMessage: string, status?: number) {
    super(body.message || fallbackMessage);
    this.name = 'ApiError';
    this.code = body.code || 'NETWORK_ERROR';
    this.requestId = body.requestId;
    this.status = status;
  }
}

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '',
  timeout: 15_000,
  withCredentials: true,
  withXSRFToken: true,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  headers: { Accept: 'application/json' },
});

http.interceptors.response.use(
  (response) => response,
  (error: AxiosError<ApiErrorBody>) => {
    const body = error.response?.data;
    throw new ApiError(
      body ?? { code: 'NETWORK_ERROR', message: '' },
      error.response ? '请求失败，请稍后重试' : '无法连接服务，请检查网络',
      error.response?.status,
    );
  },
);
